import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import GscKeywordAnalysisModal from '@/components/container/modal/article/GscKeywordAnalysisModal'

interface GscKeywordAnalysisModalState {
  siteId: number
  keyword: string
  siteUrl?: string
  days?: number
  onApply(keyword: string): void
}

const defaultValue: GscKeywordAnalysisModalState = {
  siteId: 0,
  keyword: '',
  siteUrl: undefined,
  days: undefined,
  onApply: () => undefined
}

export const GscKeywordAnalysisModalContext =
  createModalContext<GscKeywordAnalysisModalState>(defaultValue)

const GscKeywordAnalysisModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<GscKeywordAnalysisModalState>(defaultValue)
  return (
    <GscKeywordAnalysisModalContext.Provider value={state}>
      {children}
      <GscKeywordAnalysisModal />
    </GscKeywordAnalysisModalContext.Provider>
  )
}

export default GscKeywordAnalysisModalProvider
